export default __webpack_public_path__ + "static/media/trans_buy.0797d3a6.svg";